import React from "react";
import intl from "react-intl-universal";
import { mdiCheck, mdiClose } from "@mdi/js";

import commonUtils from "../../../../../../script/utils/commonUtils";

import { useInput } from "../../../../../hooks/useInput";

import { Spacer } from "../../../../../components/Spacer";
import { Button } from "../../../../../components/Button";
import { Dialog } from "../../../../../containers/Dialog";
import { DialogBody } from "../../../../../containers/DialogBody";
import { DialogFooter } from "../../../../../containers/DialogFooter";
import { InputTextArea } from "../../../../../components/InputTextArea";

export const IxusFreeTextDialog = props => {
    const text = useInput("text", "");

    const onConfirm = () => {
        if (commonUtils.isBlank(text.value)) {
            return;
        }
        props.onConfirm(text.value.trim());
    };

    return (
        <Dialog
            width="400px"
            closeIcon={false}
            title={intl.get("entry.ixus.textFields.freeTextTitle")}
            onClose={() => props.onClose()}>
            <DialogBody>
                <InputTextArea {...text.bind}
                    rows={4}
                    title={intl.get("entry.ixus.textFields.freeTextTitle")}
                    placeholder={intl.get("entry.ixus.textFields.freeTextPlaceholder")} />
            </DialogBody>
            <DialogFooter>
                <Button
                    svgIcon={mdiCheck}
                    disabled={commonUtils.isBlank(text.value)}
                    value={intl.get("common.ok")}
                    onClick={onConfirm} />
                <Spacer size="small" variant="vertical" />
                <Button
                    svgIcon={mdiClose}
                    onClick={() => props.onClose()}
                    value={intl.get("common.cancel")} />
            </DialogFooter>
        </Dialog>
    );
};
